import { appRoutes } from '@triple/triad-idp';

export const routes = appRoutes;
